import React, { useState } from "react";
import { NewBox as Box, NewSwitch as Switch } from "@bca/ui-library";
import { UpdateSavedSearchProps } from "../types";
import { useUpdateSavedSearches } from "../../hooks/useUpdateSavedSearches";
import analytics from "../../common/analytics/analytics";
import { IEventPushable } from "../../common/analytics/analytics.types";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

const SavedSearchesSwitch: React.FC<{
  params: UpdateSavedSearchProps;
  isToUseAuthZero: boolean;
}> = ({ params, isToUseAuthZero }) => {
  const { accessToken } = useAuth(!isToUseAuthZero);
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [updatedParams, setUpdatedParams] = useState(params);

  const pushStockAlertSwitchAnalytics = (toggleValue: boolean) => {
    analytics.push<IEventPushable>({
      event: {
        action: toggleValue ? "on" : "off",
        category: "toggle",
        label: "stock-alert",
        name: "click",
        section: "",
      },
    });
  };

  const onSwitchClick = () => {
    pushStockAlertSwitchAnalytics(!updatedParams?.notifyMe);
    setUpdatedParams({
      ...updatedParams,
      notifyMe: !updatedParams?.notifyMe,
    });
    setShouldUpdate(true);
  };

  useUpdateSavedSearches(
    updatedParams,
    shouldUpdate,
    setShouldUpdate,
    null,
    isToUseAuthZero,
    accessToken
  );

  return (
    <Box>
      <Switch
        disabled={shouldUpdate}
        onChange={onSwitchClick}
        defaultChecked={params.notifyMe}
      />
    </Box>
  );
};

export default SavedSearchesSwitch;
